import React from "react";

function ViewBlockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21">
      <path
        stroke="#D32F2F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.2"
        d="M10.414 18.553c4.6 0 8.334-3.733 8.334-8.333s-3.734-8.333-8.334-8.333a8.336 8.336 0 00-8.333 8.333c0 4.6 3.733 8.333 8.333 8.333zM16.164 4.387L4.497 16.053"></path>
    </svg>
  );
}

export default ViewBlockIcon;
